import { render, staticRenderFns } from "./PartnersResposes.vue?vue&type=template&id=4c100c4e&"
import script from "./PartnersResposes.vue?vue&type=script&lang=js&"
export * from "./PartnersResposes.vue?vue&type=script&lang=js&"
import style0 from "./PartnersResposes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VDataTable})
